<div class="time-picker-container">
  <div class="title" *ngIf="timeOfDay">
    <svg-icon class="icon" [src]="svgURL"></svg-icon>
    {{ timeOfDay }} Reminders
  </div>
  <div class="picker">
    <div class="select-time">
      <button class="time-adjust" (click)="adjustTime(timeProperty.hour, 1)">
        <svg-icon src="/assets/icons/chevron-left-nocircle.svg"></svg-icon>
      </button>
      <input
        class="time-input"
        *ngIf="showHourInput"
        #hourInput
        type="number"
        [value]="hour"
        [min]="minHour"
        [max]="maxHour"
        (blur)="inputTime(timeProperty.hour, hourInput.value)"
        (keyup.enter)="inputTime(timeProperty.hour, hourInput.value)"
        autofocus />
      <button class="time-adjust" *ngIf="!showHourInput" (click)="showTimePropertyInput(timeProperty.hour)">
        {{ hour }}
      </button>
      <button class="time-adjust" (click)="adjustTime(timeProperty.hour, -1)">
        <svg-icon src="/assets/icons/chevron-right-nocircle.svg"></svg-icon>
      </button>
    </div>
    <div class="select-time">:</div>
    <div class="select-time">
      <button class="time-adjust" (click)="adjustTime(timeProperty.minutes, 1)">
        <svg-icon src="/assets/icons/chevron-left-nocircle.svg"></svg-icon>
      </button>
      <input
        class="time-input"
        *ngIf="showMinInput"
        #minutesInput
        type="number"
        [value]="minutes"
        min="00"
        max="45"
        step="15"
        (blur)="inputTime(timeProperty.minutes, minutesInput.value)"
        (keyup.enter)="inputTime(timeProperty.minutes, minutesInput.value)"
        autofocus />
      <button class="time-adjust" *ngIf="!showMinInput" (click)="showTimePropertyInput(timeProperty.minutes)">
        {{ minutes }}
      </button>
      <button class="time-adjust" (click)="adjustTime(timeProperty.minutes, -1)">
        <svg-icon src="/assets/icons/chevron-right-nocircle.svg"></svg-icon>
      </button>
    </div>
    <div class="select-time" *ngIf="!is24HrFormat">
      <button class="time-adjust" (click)="adjustTime(timeProperty.amPM, 1)">
        <svg-icon src="/assets/icons/chevron-left-nocircle.svg"></svg-icon>
      </button>
      <button class="time-adjust" (click)="adjustTime(timeProperty.amPM, 1)">
        {{ AMPM }}
      </button>
      <button class="time-adjust" (click)="adjustTime(timeProperty.amPM, -1)">
        <svg-icon src="/assets/icons/chevron-right-nocircle.svg"></svg-icon>
      </button>
    </div>
  </div>
  <div class="button-row">
    <button class="button-cancel" (click)="closeClicked.emit()">Close</button>
    <button class="button button-reverse button-pill button-save" (click)="save()">Save</button>
  </div>
</div>
